import { isEmail, urlRegex } from '../utils/validation'

const businessTypeOptions = [
  {
    labelKey: 'partnershipsForm.businessTypes.association',
    value: 'Association',
  },
  {
    labelKey: 'partnershipsForm.businessTypes.affiliateMarketer',
    value: 'Affiliate marketer',
  },
  {
    labelKey: 'partnershipsForm.businessTypes.careerSite',
    value: 'Career site',
  },
  {
    labelKey: 'partnershipsForm.businessTypes.contentPublisher',
    value: 'Content publisher',
  },
  {
    labelKey: 'partnershipsForm.businessTypes.jobBoard',
    value: 'Job board',
  },
  {
    labelKey: 'partnershipsForm.businessTypes.reviewSite',
    value: 'Review site',
  },
  {
    labelKey: 'partnershipsForm.businessTypes.staffingAgency',
    value: 'Staffing agency',
  },
  {
    labelKey: 'partnershipsForm.businessTypes.university',
    value: 'University',
  },
  {
    labelKey: 'partnershipsForm.businessTypes.other',
    value: 'Other',
  },
] as const

function isValidBusinessType(value: string) {
  return businessTypeOptions.map((i) => i.value).includes(value as any)
}

const isValidURL = (url: string) => urlRegex.test(url)

function validateSchema(obj: PartnerFormFields) {
  const buf = {} as PartnerFormFieldsErrorMessages

  for (const key of Object.keys(obj)) {
    const field = (obj as any)[key].trim()

    if (!field?.length) {
      if (key === 'partnerships_first_name') {
        buf['partnerships_first_name_error_message'] =
          'partnershipsForm.validationMessages.firstname'
      }
      if (key === 'partnerships_last_name') {
        buf['partnerships_last_name_error_message'] =
          'partnershipsForm.validationMessages.lastname'
      }
      if (key === 'partnerships_email') {
        buf['partnerships_email_error_message'] =
          'partnershipsForm.validationMessages.email'
      }
      if (key === 'partnerships_job_board') {
        buf['partnerships_job_board_error_message'] =
          'partnershipsForm.validationMessages.jobboard'
      }
      if (key === 'partnerships_message') {
        buf['partnerships_message_error_message'] =
          'partnershipsForm.validationMessages.message'
      }
      if (key === 'partnerships_business_type') {
        buf['partnerships_business_type_error_message'] =
          'partnershipsForm.validationMessages.businessType'
      }
    }

    if (key === 'partnerships_email' && !isEmail(field)) {
      buf['partnerships_email_error_message'] =
        'partnershipsForm.validationMessages.emailInvalid'
    }

    if (key === 'partnerships_job_board' && !isValidURL(field)) {
      buf['partnerships_job_board_error_message'] =
        'partnershipsForm.validationMessages.jobboardInvalid'
    }
  }

  return buf
}

type PartnerFormFields = {
  partnerships_first_name: string
  partnerships_last_name: string
  partnerships_email: string
  partnerships_job_board: string
  partnerships_message: string
  partnerships_business_type: string
}

type PartnerFormFieldsErrorMessages = {
  [Key in keyof PartnerFormFields as `${string & Key}_error_message`]:
    | string
    | null
}

type PartnerFormFieldKeys = keyof PartnerFormFields

export { businessTypeOptions, isValidBusinessType, validateSchema }

export type { PartnerFormFieldKeys, PartnerFormFields }
